var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-space-inbetween"},[_c('b-row',{attrs:{"aligh-v":"start"}},[_c('b-col',[_vm._t("you",[_vm._v("You")])],2),_c('b-col',{attrs:{"cols":"auto"}},[_vm._t("me",[_vm._v("Me")])],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }